import { ExternalLink } from 'lucide-react';
import type { HelpRelatedLink } from '@/content/help/types';
import { useHelp } from './useHelp';

interface HelpRelatedLinksProps {
  links: HelpRelatedLink[];
}

export function HelpRelatedLinks({ links }: HelpRelatedLinksProps) {
  const { closeHelp } = useHelp();

  if (links.length === 0) {
    return null;
  }

  const handleLinkClick = () => {
    // Close the help panel when navigating to a related link
    closeHelp();
  };

  return (
    <div className="mt-6 pt-4 border-t border-border">
      <h3 className="text-sm font-semibold text-foreground mb-3">Related Topics</h3>
      <ul className="space-y-2">
        {links.map((link, index) => (
          <li key={index}>
            <a
              href={link.href}
              onClick={handleLinkClick}
              className="group flex items-start gap-2 p-2 -mx-2 rounded-md hover:bg-muted transition-colors"
            >
              <ExternalLink className="h-4 w-4 mt-0.5 text-muted-foreground group-hover:text-primary-500 flex-shrink-0" />
              <div>
                <span className="text-sm font-medium text-foreground group-hover:text-primary-600">
                  {link.title}
                </span>
                {link.description && (
                  <p className="text-xs text-muted-foreground mt-0.5">
                    {link.description}
                  </p>
                )}
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
